import { StringParam } from 'use-query-params'

import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import type { CheckingPricesCompetitorsDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'
export const tableSearchQuerySchema: TableSearchQuerySchema<CheckingPricesCompetitorsDataSource> = {
  'table-configName': StringParam
} as const

export const columnsSearchSchema: ColumnTableSearchSchema<CheckingPricesCompetitorsDataSource> = {
  configName: { type: columnSearchSchemaOptionType.INPUT }
}
